import { BaseAction } from "../../../core/actions/BaseAction";
import { updateRecoilState } from "../../../Orchestrator/Recoils/Events/Recoil";
import { getPlaces } from "../../../app/api/getPlaces";
import { IApiResponse, StationsListType } from "../../../Orchestrator/Types/Index";

export class UpdatedStopsAction extends BaseAction<void, { data: any }> {
  // Helper function to get updated stops with geoPosition
  private async getUpdatedStops(StopsList: StationsListType, places: any[]) {
    return await Promise.all(
      StopsList.map(async (stop: any) => {
        const matchingPlace = places.find(
          (place: any) => place?.id?.toString() === stop?.id?.toString()
        );
        const stopGeoPosition = matchingPlace ? matchingPlace.geoPosition : null;

        const updatedSubStations = await Promise.all(
          stop.subStations.map(async (subStation: any) => {
            const matchingSubPlace = places.find(
              (place: any) => place?.id?.toString() === subStation?.id?.toString()
            );
            const subStationGeoPosition = matchingSubPlace ? matchingSubPlace.geoPosition : null;

            return {
              ...subStation,
              geoPosition: subStationGeoPosition,
            };
          })
        );

        return {
          ...stop,
          geoPosition: stopGeoPosition,
          subStations: updatedSubStations,
        };
      })
    );
  }

  override async run(): Promise<void | null> {
    try {
      const { data } = this.params!;
      let StopsList: any = data;

      const response: IApiResponse<{ places: any }> = await getPlaces();
      if (response.status !== "ok" || !response.answer) return;

      const places = response.answer.places;
      StopsList = await this.getUpdatedStops(StopsList, places);

      updateRecoilState("updatedStopsAtom", StopsList);
    } catch (error) {
      console.error("Error in UpdatedStopsAction:", error);
    }
  }
}

// Create a singleton instance
export const updatedStopsAction = new UpdatedStopsAction();
